import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../../utils";
export const DialogShellBody = /*#__PURE__*/ React.forwardRef(function DialogShellBody({ padding = "px-6 py-5", scroll = true, className, children, ...props }, ref) {
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: cn("flex flex-1 min-h-0 flex-col gap-4.5", padding, scroll ? "overflow-y-auto" : "overflow-visible", className),
        ...props,
        children: children
    });
});

//# sourceMappingURL=DialogShellBody.js.map